export default {
  RECAPTCHA_V2_INVISIBLE: 'RECAPTCHA_V2_INVISIBLE',
  RECAPTCHA_V2_VISIBLE: 'RECAPTCHA_V2_VISIBLE',
  DISABLED: 'DISABLED',
};
